import React, { useEffect, useState } from "react";
import axios from "axios";
import { isUser } from "../../Config/isUser";
import MyAppliedPostCard from "./MyAppliedPostCard";
import { Alert, AlertTitle } from "@mui/material";

const MyAppliedPosts = () => {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get(
          "https://kariyer.biyomed.net/api/posts/getUserAppliedPosts",
          { withCredentials: true }
        );
        setPosts(response.data.jobs);
        console.log(response.data);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    // if (posts.length === 0) { // Sadece 'posts' boş olduğunda çalışır
    //   fetchUsers();
    // }
    fetchUsers();
  }, []);

  return (
    <div className="jp_listing_sidebar_main_wrapper">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="jp_listing_heading_wrapper">
              <h2>
                Sizin için <span>{posts.length}</span> Eşleşme bulduk
              </h2>
            </div>
          </div>
          <div className="col-lg-3 col-md-3 col-sm-12 col-xs-12 hidden-sm hidden-xs">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="jp_add_resume_wrapper jp_job_location_wrapper">
                  <div className="jp_add_resume_img_overlay" />
                  {isUser ? (
                    <div className="jp_add_resume_cont">
                      <img
                        style={{ width: "120px", height: "30px" }}
                        src="https://biyomed.net/kariyer_images/biyomedlogosiyahzemin2.png"
                        alt="logo"
                      />
                      <h4>
                        İşverenlerin dikkatini çekmek için Profilinizi
                        güçlendirin
                      </h4>
                      <ul>
                        <li>
                          <a href="/userprofile">
                            <i className="fa fa-plus-circle" /> &nbsp;Profilim
                          </a>
                        </li>
                      </ul>
                    </div>
                  ) : (
                    <div className="jp_add_resume_cont">
                      <img src="images/content/resume_logo.png" alt="logo" />
                      <h4>
                        İşverenlerin dikkatini çekmek için Profilinizi
                        güçlendirin
                      </h4>
                      <ul>
                        <li>
                          <a href="/login"> &nbsp;Giriş yapınız</a>
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="tab-content">
                  <div id="grid" className="tab-pane fade in active">
                    <div className="row"> {posts.length === 0 &&
                        <Alert sx={{marginTop:5}} severity="info">
                        <AlertTitle>Hatırlatma...</AlertTitle>
                        İlanlara başvurmak için profil kaydınızı hesabım sekmesinden tamamlamalısınız!
                      </Alert>}

                      {posts.map((post) => {
                        return <MyAppliedPostCard key={post.id} post={post} />;
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyAppliedPosts;
